import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"width":"60%","margin-left":"auto","margin-right":"auto"} }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = {
  key: 1,
  style: {"width":"24px"},
  class: "me-5"
}
const _hoisted_4 = { class: "d-flex justify-space-between align-center" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { key: 1 }

import { withDefaults, computed } from 'vue';
import { IProgressPhased } from '@/types';
import * as  comps from '@/components/atoms';
import { formatPercentage } from '@/utils/formatNumber';

interface IProps {
  values?: IProgressPhased[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AtomPhasedProgress',
  props: {
    values: {}
  },
  setup(__props: any) {

const icon = computed(() => {
  return props.values ? props.values.filter(f => f.icon).length ? props.values.find(f => f.icon)?.icon : undefined : undefined;
});

const percentage = computed(() => {
  let aux_percent = 0;
  if (props.values) {
    props.values.map(p => { aux_percent = p.percent > 0 ? p.percent : aux_percent });
  }
  return aux_percent;
});

const color = computed(() => {
  let aux_color = "006EE2";
  if (props.values) {
    props.values.map(p => aux_color = p.progressColor ? p.progressColor : aux_color);
  }
  return aux_color;
});

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (icon.value)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(comps[icon.value]), {
            key: 0,
            class: "me-5"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.values, (item, index) => {
        return (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: String(index),
          color: item.progressColor,
          class: "mx-2",
          modelValue: item.percent,
          "onUpdate:modelValue": ($event: any) => ((item.percent) = $event),
          height: 10,
          max: item.max ?? 100,
          rounded: "",
          style: {"width":"48px","left":"0 !important"}
        }, null, 8, ["color", "modelValue", "onUpdate:modelValue", "max"]))
      }), 128)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", {
          style: _normalizeStyle({ color: color.value }),
          class: "ms-4 text-xs font-500"
        }, [
          (percentage.value > 100)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                title: 'O progresso atual é: ' + _unref(formatPercentage)(Number(percentage.value))
              }, " ↑ 100% ", 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(formatPercentage)(Number(percentage.value))), 1))
        ], 4)
      ])
    ])
  ]))
}
}

})